"use client"

import { usePathname } from "next/navigation"
import { SignalAlertsModal } from "@/components/signal-alerts-modal"
import { SignalLeaderboard } from "@/components/signal-leaderboard"

const EXCLUDED_PATHS = ["/onboarding", "/auth"]

export function AppOnlyModals() {
  const pathname = usePathname()
  if (EXCLUDED_PATHS.some((p) => pathname?.startsWith(p))) return null
  return (
    <>
      <SignalAlertsModal />
      <SignalLeaderboard />
    </>
  )
}
